import { render } from "./LayoutScreen.vue?vue&type=template&id=e15ef4a6&scoped=true"
import script from "./LayoutScreen.vue?vue&type=script&lang=js"
export * from "./LayoutScreen.vue?vue&type=script&lang=js"

import "./LayoutScreen.vue?vue&type=style&index=0&id=e15ef4a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15ef4a6"]])

export default __exports__